// Environment configuration for React app
// This file safely handles environment variables and prevents "process is not defined" errors

// Safe environment variable access
const getEnvVar = (key, defaultValue = '') => {
  try {
    // In React, only REACT_APP_ prefixed variables are available in the browser
    // Prioritize import.meta.env for modern bundlers (Vite, Parcel)
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key] !== undefined) {
      return import.meta.env[key];
    }
    // Fallback to process.env for older bundlers (Create React App, Webpack)
    if (typeof process !== 'undefined' && process.env && process.env[key] !== undefined) {
      return process.env[key];
    }
    // Fallback to a global window.env if explicitly set (e.g., by a custom build script)
    if (typeof window !== 'undefined' && window.env && window.env[key] !== undefined) {
      return window.env[key];
    }
    return defaultValue;
  } catch (error) {
    console.warn(`Environment variable ${key} not accessible:`, error.message);
    return defaultValue;
  }
};

// Environment configuration
const config = {
  // API Configuration
  API_URL: getEnvVar('REACT_APP_API_URL', '/api'),
  BASE_URL: getEnvVar('REACT_APP_BASE_URL', window.location.origin),
  
  // Environment detection
  ENV: getEnvVar('REACT_APP_ENV', 'production'),
  NODE_ENV: getEnvVar('REACT_APP_NODE_ENV', 'production'),
  
  // Development flags
  IS_DEVELOPMENT: getEnvVar('REACT_APP_ENV', 'production') === 'development',
  
  IS_PRODUCTION: getEnvVar('REACT_APP_ENV', 'production') === 'production',
  
  // Build configuration
  GENERATE_SOURCEMAP: getEnvVar('GENERATE_SOURCEMAP', 'false') === 'true',
  PUBLIC_URL: getEnvVar('PUBLIC_URL', '/'),
  
  // Feature flags
  ENABLE_DEBUG_LOGGING: getEnvVar('REACT_APP_ENV', 'production') === 'development',
  ENABLE_CONSOLE_LOGS: getEnvVar('REACT_APP_ENV', 'production') === 'development',
};

// Validate required configuration
const validateConfig = () => {
  const required = ['API_URL', 'BASE_URL'];
  const missing = required.filter(key => !config[key]);
  
  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing);
    // Don't throw error in production, use defaults
    if (config.IS_DEVELOPMENT) {
      console.warn('Using default values for missing environment variables');
    }
  }
};

// Run validation
validateConfig();

// Export configuration
export default config;

// Export individual values for convenience
export const {
  API_URL,
  BASE_URL,
  ENV,
  NODE_ENV,
  IS_DEVELOPMENT,
  IS_PRODUCTION,
  GENERATE_SOURCEMAP,
  PUBLIC_URL,
  ENABLE_DEBUG_LOGGING,
  ENABLE_CONSOLE_LOGS
} = config;
